import { injectGlobal } from 'styled-components'

injectGlobal`
  .ReactModal__Overlay {
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.8) !important;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    & > .ReactModal__Content {
      position: relative !important;
    }
  }
`



// WEBPACK FOOTER //
// ./src/containers/PreviewFrame/theme.js